import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import {DirectorConstants} from '../app.constants';
import { AppUtilityService } from '../common/app-utility.service';
import { environment,countryCodes } from 'src/environments/environment.prod'

declare var $: any;

@Component({
  selector: 'app-second-director-details',
  templateUrl: './second-director-details.component.html',
  styleUrls: ['./second-director-details.component.scss']
})
export class SecondDirectorDetailsComponent implements OnInit {
  ServiceBody: FormGroup;
  refSCDL: any;
  refCCDL: any;
  ResponseBody:any;
  InitialLoad : boolean;
  countrycodechanged : string;
    second_director_name: string;
  second_director_nric: string;
  second_director_email: string;
  second_director_mobile: string;
  check_owner : boolean;
  isEditMode: boolean = false;
  postalCodeMaxLength = '5';
  postalCodeMinLength = '5'
  isValidNRIC:boolean = true;
  CountryCodes = countryCodes;
  
  constructor(public router: Router,public appComp: AppComponent,
    private formBuilder: FormBuilder,
    private connectRestService: ConnectRestService,
    private activatedRoute: ActivatedRoute,
    private AppUtility : AppUtilityService) { }

  // (Begin) Added by CJT / Code by Sonny 09Jul2020
  //change request for SIR 9 and 14 --- start
  // find word 'onPaste="return false" onDrop="return false" onDrag="return false"' for relevant change in HTML
  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue){
    if(elemValue.target.id==="second_director_nric" || elemValue.target.id==="second_director_postcode"){ 
      return this.AppUtility.numericOnlyValidation(elemValue.key)
    }else if(elemValue.target.type ==='text'){
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }
  // (End) CJT / Sonny 09Jul2020
  onSubmit() {
    if ($("#obaoform").valid()) {
      this.InitialLoad = false;
     // console.log(this.ServiceBody.value.check_owner_ultimate);
      if(this.ServiceBody.controls['check_owner_ultimate'].value){

      this.check_owner = true;
    }else{
      this.check_owner = false;
    }
    var data = {
      "ApplicantList": [{
        "AddressInfo": [{
          "AddressType": "H",
          "AddressLine1": this.ServiceBody.value.second_director_address,
          "AddressLine2": this.ServiceBody.value.second_director_address_2,
          "AddressLine3": this.ServiceBody.value.second_director_address_3,
          "AddressLine4": this.ServiceBody.value.second_director_address_4,
          "CountryCode": this.ServiceBody.value.second_director_country,
          "PostalCode": this.ServiceBody.value.second_director_postcode,
          "StateCode": this.ServiceBody.value.second_director_state,
        }
        ],
        "ContactInfo": [{
          "Type": "EM",
          "Value": this.ServiceBody.controls['second_director_email'].value
        }, {
          "Type": "PM",
          "Value": this.ServiceBody.controls['second_director_countryCode'].value+"-"+this.ServiceBody.controls['second_director_mobile'].value
        }
        ],
        "NRIC": this.ServiceBody.value.second_director_nric,
        "Name": this.ServiceBody.controls['second_director_name'].value,
        "UltimateOwner": this.check_owner
      }]
    }
    this.restConnect(data);
    }
  }

  ngOnInit() {
    this.InitialLoad = true;
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    this.ServiceBody = this.formBuilder.group({})   
  
   this.restConnect({})

    $(document).ready(function () {   
        /* DCI update (29 June 2020): Add function to change maxlength of postcode*/
        $("#second_director_country").change(function(){
          if($("#second_director_country").val() == "MY"){
            $("#second_director_postcode").attr("maxlength",5);
            $("#second_director_postcode").attr("minlength",5);
          }else{
            $("#second_director_postcode").attr("maxlength",9);
            $("#second_director_postcode").attr("minlength",1);
          }
          $("#obaoform").validate().element("#second_director_postcode");
        });

      $("#second_director_country").change(function () {
        if ($("#second_director_country").val() == "MY") {
          $("#second_director_address_4").addClass("hidden");
          $("#state-sec").show();
        } else {
          $("#second_director_address_4").removeClass("hidden");
          $("#state-sec").hide();
        }
      })
       //DCI update (15/7/2020): Disable keypress enter or other to navigate page
       $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      })

      $.validator.setDefaults({
        ignore:".ignore"
      });
  
      var validator = $("#obaoform").validate({
        rules: {
          second_director_nric: {
            required: true,
            number:true
          },
          second_director_address: {
            required: true
          },

          second_director_postcode:{
            required: true,
            number: true
          },
          second_director_state:{
            required: 
            {
              depends: function () {
                if ($("#second_director_country").val() == "MY") {
                  return true;
                } else {
                  return false;
                }

              }
            }
          },
          second_director_country:{
            required: true
          }



        },
        messages: {
          second_director_nric: {
            required: "Please enter identification number",
            number: "Identification number must be numeric",
            pattern: "Please enter valid format"
          },
          second_director_address: {
            required: "Please enter residential address"
          },
          
          second_director_postcode:{
            required: "Please enter postcode number",
            number: "Postcode should be numeric",
            maxlength : "Postcode should be no more than {0} numeric characters.",
            minlength : "Please enter at least {0} numeric characters."
          },
          second_director_state:{
            required: "Please select an option"
          },
          second_director_country:{
            required: "Please select an option"
          }
  

        },
        errorPlacement: function (error, element) {
       

          if (element.attr("name") == "second_director_nric") {
            error.appendTo("#second_director_nric_error_container");
          }
       
          if (element.attr("name") == "second_director_address") {
            error.appendTo("#second_director_address_error_container");
          }

          if (element.attr("name") == "second_director_postcode") {
            error.appendTo("#second_director_postcode_error_container");
          }
          if (element.attr("name") == "second_director_state") {
            error.appendTo("#second_director_state_error_container");
          }
          if (element.attr("name") == "second_director_country") {
            error.appendTo("#second_director_country_error_container");
          }
       
        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }


      });


    });
    this.callDropdownValues().then(this.appComp.loadCustomDropdown);

    this.ServiceBody = this.formBuilder.group({
      second_director_name: [{value: '', disabled: true}, Validators.required],
      second_director_nric: ['', Validators.required],
      second_director_email: [{value: '', disabled: true}, [Validators.required, Validators.pattern(environment.emailPatternHTML5)]],
      second_director_mobile: [{value: '', disabled: true}, Validators.required],
      second_director_countryCode:[{value: '', disabled: true}],
      check_owner_ultimate: [{value: '', disabled: true}],
      second_director_address:['', Validators.required],
      second_director_address_2:[''],
      second_director_address_3:[''],
      second_director_address_4:[''],
      second_director_postcode:['', Validators.required],
      second_director_country:['',Validators.required],
      second_director_state:['', Validators.required]

    }); 
    
    $(".chk-cont").css("opacity", ".5");
  }
  async callDropdownValues() {
    this.refSCDL = JSON.parse(sessionStorage.RefSCDL);
    this.refCCDL = JSON.parse(sessionStorage.RefCCDL);


}
  public countryChange(event) {
    if (event.target.value === DirectorConstants.MALAYSIA) {
      this.ServiceBody.controls['second_director_address_4'].setValue('');
      this.ServiceBody.controls["second_director_state"].setValidators([Validators.required]);;
      this.ServiceBody.controls["second_director_state"].updateValueAndValidity();
      this.postalCodeMaxLength = '5';
      this.postalCodeMinLength = '5'
    } else {
      this.ServiceBody.controls['second_director_state'].setValue('');
      this.clearStateValidators();
      this.postalCodeMaxLength = '9';
      this.postalCodeMinLength = '1';
    }
  }

  public clearStateValidators(){
    this.ServiceBody.controls["second_director_state"].clearValidators();
    this.ServiceBody.controls["second_director_state"].updateValueAndValidity();
  }

   async restConnect(data){
   
    if(this.InitialLoad){
      var RequestID = "R0200"
    }else{
      var RequestID = "S0200"
    }    
    var responseData = await this.connectRestService.connectRest(data,RequestID,'')
    if(responseData.Status == "Success"){
      if(this.InitialLoad){
      this.setFormData(responseData);
      } else {
        if (!this.isEditMode) {
          this.router.navigate(['/upload-nric']);
        } else {
          this.router.navigate(['/director-confirm']);
        }
      }
    }else{      
      this.ResponseBody = responseData;
    }
  }  


  public setFormData(data) {
      this.ServiceBody.controls['second_director_name'].setValue(data.ApplicantList[0].Name);         
      this.ServiceBody.controls['second_director_mobile'].setValue(data.ApplicantList[0].ContactInfo[1].Value.split('-')[1]);
      this.ServiceBody.controls['second_director_countryCode'].setValue(data.ApplicantList[0].ContactInfo[1].Value.split('-')[0]);
   //   console.log("split countrycode..."+ data.ApplicantList[0].AddressInfo[0].CountryCode.split('-')[0]);
     // console.log("split mobile..."+ data.ApplicantList[0].AddressInfo[0].CountryCode.split('-')[1]);
    this.ServiceBody.controls['second_director_email'].setValue(data.ApplicantList[0].ContactInfo[0].Value);
    this.ServiceBody.controls['second_director_nric'].setValue(data.ApplicantList[0].NRIC);
    this.ServiceBody.controls['check_owner_ultimate'].setValue(data.ApplicantList[0].UltimateOwner);
    //set state default value to W.P Kuala Lumpur and country to MY
    //Added by Sonny
    this.ServiceBody.controls['second_director_state'].setValue(environment.stateCode)
    this.ServiceBody.controls['second_director_country'].setValue(environment.countryCode);

    if (data.ApplicantList[0].AddressInfo && data.ApplicantList[0].AddressInfo.length > 0) {
      this.ServiceBody.controls['second_director_country'].setValue(data.ApplicantList[0].AddressInfo[0].CountryCode);
      this.ServiceBody.controls['second_director_address'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine1);
      this.ServiceBody.controls['second_director_address_2'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine2);
      this.ServiceBody.controls['second_director_address_3'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine3);
      this.ServiceBody.controls['second_director_address_4'].setValue(data.ApplicantList[0].AddressInfo[0].AddressLine4);
      this.ServiceBody.controls['second_director_postcode'].setValue(data.ApplicantList[0].AddressInfo[0].PostalCode);
      this.ServiceBody.controls['second_director_state'].setValue(data.ApplicantList[0].AddressInfo[0].StateCode);
      if (data.ApplicantList[0].AddressInfo[0].CountryCode === DirectorConstants.MALAYSIA) {
        this.ServiceBody.controls['second_director_address_4'].setValue('');
      } else {
        this.ServiceBody.controls['second_director_state'].setValue('');
        this.clearStateValidators();
        this.postalCodeMaxLength = '9';
        this.postalCodeMinLength = '1';
        $("#second_director_address_4").removeClass("hidden");
        $("#state-sec").hide();
      }
    }
  }

  public validateNRIC(nric){
    if(nric){
      this.isValidNRIC = this.AppUtility.nricValidation(nric);
    }
  }
 
}

